// File: src/components/ui/ScheduleFeed/ScheduleFeed.tsx

import React from "react";
import styled from "styled-components";
import { Flex } from "../../layouts/wrappers";
import { Typography } from "../../general/Typography";
import { Button } from "../../general/Button";
import { ScheduleCard, ScheduleCardProps } from "./ScheduleCard";

export interface ScheduleFeedProps {
  title?: string;
  items: ScheduleCardProps[];
  onSeeMore?: () => void;
}

const FeedContainer = styled(Flex)`
  flex-direction: column;
  background: ${({ theme }) => theme.colors.surfaceAlt};
  padding: ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.radii.lg};
  box-shadow: ${({ theme }) => theme.elevations.low};
  width: 100%;
  gap: ${({ theme }) => theme.spacing.md};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.spacing.sm};
    border-radius: ${({ theme }) => theme.radii.md};
  }
`;

const FeedHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing.xs};
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding-top: ${({ theme }) => theme.spacing.xs};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    justify-content: center;
    width: 100%;
  }
`;

export const ScheduleFeed: React.FC<ScheduleFeedProps> = ({
  title = "Today’s Schedule",
  items,
  onSeeMore,
}) => {
  return (
    <FeedContainer>
      <FeedHeader>
        <Typography variant="heading2" as="h2">
          {title}
        </Typography>
      </FeedHeader>

      {items.map((item, idx) => (
        <ScheduleCard key={idx} {...item} />
      ))}

      {onSeeMore && (
        <Footer>
          <Button variant="flat" size="small" onClick={onSeeMore}>
            See more
          </Button>
        </Footer>
      )}
    </FeedContainer>
  );
};